export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getTimeTypeList: function getTimeTypeList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/time_type/get",
        method: "get",
        params: data
      });
    },
    addTimeType: function addTimeType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/time_type/add",
        method: "post",
        data: data
      });
    },
    updateTimeType: function updateTimeType() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/time_type/update",
        method: "post",
        data: data
      });
    }
  };
});